import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/intel/Layout";
import { ModuleShell } from "@/components/intel/ModuleShell";
import { ImageIntelPanel } from "@/components/intel/ImageIntelPanel";

export const Route = createFileRoute("/imagery")({
  head: () => ({
    meta: [
      { title: "Image Intelligence · CARIO INTEL" },
      { name: "description", content: "Upload an image to extract EXIF, OCR text, landmarks, logos, probable location, similar imagery and manipulation signals." },
      { property: "og:title", content: "Image Intelligence · CARIO INTEL" },
      { property: "og:description", content: "OSINT image analysis: EXIF, OCR, landmarks, logos, geolocation clues, reverse search and manipulation detection." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: ImageryPage,
  errorComponent: ({ error }) => (
    <AppLayout>
      <div className="p-6 text-sm text-danger">Image intelligence failed to load: {error.message}</div>
    </AppLayout>
  ),
  notFoundComponent: () => (
    <AppLayout>
      <div className="p-6 text-sm text-muted-foreground">Not found.</div>
    </AppLayout>
  ),
});

function ImageryPage() {
  return (
    <AppLayout>
      <ModuleShell
        eyebrow="IMINT"
        title="Image intelligence"
        description="Upload an image and the analyst engine reads EXIF locally in your browser, then runs vision analysis for landmarks, logos, OCR text, probable location, manipulation signals, similar imagery and reverse-search pivots."
      >
        <ImageIntelPanel />
      </ModuleShell>
    </AppLayout>
  );
}